export function createMaterial() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    Descripcion: '',
    ClaveErp: '',
    Umedida: '',
    GrupoMaterial: '',
    CuentaContable: '',
    TipoArticulo: '',
    EsInventariable: false,
    EsDeCompra: false,
    EsDeVenta: false,
    EsActivo: true,
    UltimoPrecioCompra: 0,
    PrecioPromedio: 0,
    PrecioUltimo: 0,
    PrecioMinimo: 0,
    PrecioMaximo: 0,
    Impuesto1: '',
    Impuesto2: '',
    Impuesto3: '',
    CuentaContableCosto: '',
    CuentaContableVenta: '',
    CuentaContableGasto: ''
  };
}
